export const sizeMapping: Record<string, string[]> = {
    // standard sizes
    "xxs": ["xxs"],
    "xs": ["xs", "xs-75 cm"],
    "s": ["s", "s-80 cm"],
    "m": ["m", "m-85 cm"],
    "l": ["l", "l-90 cm"],
    "xl": ["xl", "xl-95 cm"],
    "2xl": ["2xl", "xxl-100 cm"],
    "3xl": ["3xl"],
    "4xl": ["4xl"],
    "5xl": ["5xl"],
  
    // ind sizes
    "ind-6": ["ind-6"],
    "ind-7": ["ind-7"],
    "ind-8": ["ind-8"],
    "ind-9": ["ind-9"],
    "ind-10": ["ind-10"],
    "ind-11": ["ind-11"],
  
    // uk shoe sizes
    "4 uk": ["4 uk", "uk 4"],
    "5 uk": ["5 uk", "uk 5"],
    "6 uk": ["6 uk", "uk 6"],
    "7 uk": ["7 uk", "uk 7"],
    "8 uk": ["8 uk", "uk 8"],
    "9 uk": ["9 uk", "uk 9"],
    "10 uk": ["10 uk", "uk 10"],
    "11 uk": ["11 uk", "uk 11"],
  
    // numeric sizes
    "22": ["22"],
    "24": ["24"],
    "26": ["26"],
    "27": ["27"],
    "28": ["28"],
    "29": ["29"],
    "30": ["30"],
    "31": ["31"],
    "32": ["32"],
    "33": ["33"],
    "34": ["34"],
    "35": ["35"],
    "36": ["36"],
    "37": ["37"],
    "38": ["38"],
    "39": ["39"],
    "40": ["40"],
    "41": ["41"],
    "42": ["42"],
    "43": ["43"],
    "44": ["44"],
  
    // free size
    "free size": ["free size"]
  };
  